import { render, staticRenderFns } from "./AdminAppbar.vue?vue&type=template&id=687f60ec"
import script from "./AdminAppbar.vue?vue&type=script&lang=js"
export * from "./AdminAppbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports